import { Tooltip, TooltipContent, TooltipTrigger } from '@cuspar/ui';
import { Info } from 'lucide-react';
import { ReactNode } from 'react';

export const InfoTooltip = ({ info }: { info?: ReactNode }) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Info className='h-4 w-4 text-muted-foreground' />
      </TooltipTrigger>
      <TooltipContent className='max-w-md'>{info}</TooltipContent>
    </Tooltip>
  );
};
